import { CheckBoxIcon } from '@/assets/icons/icons';
import { TRIGGER_ICON_COLOR } from '../../styles';
import { NodeCategory, OutputType, type LBNodeInfo } from '../../types';
import { buildNodeData } from '../../nodeDataUtils';
import { AlertActionTakenTriggerWithTagFilter } from './AlertActionTakenTriggerWithTagFilter';
import type { ValidationError } from '../../fieldValidation';

export const AlertActionTakenTriggerFields = {
  ALERT_TYPES: 'Alert type',
  ACTION_TAKEN: 'Action taken',
} as const;

export const AlertActionTakenTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'alert_action_taken_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Alert action taken',

  hasInput: false,

  showCustomizePanelOnCreation: true,

  getIcon: (size: number) => (
    <CheckBoxIcon width={size} height={size} fill={TRIGGER_ICON_COLOR} />
  ),

  outputType: OutputType.SINGLE,

  getValidationErrors: (_nodeId, nodeData, _graph) => {
    const d = nodeData.alert_action_taken_trigger;
    const errors: ValidationError[] = [];
    if (!d?.select_all_alert_types && (d?.alert_types?.length ?? 0) === 0) {
      errors.push({
        type: 'REQUIRED_FIELD',
        field: AlertActionTakenTriggerFields.ALERT_TYPES,
        message: 'At least one alert type must be selected.',
      });
    }
    if (!d?.select_all_action_taken && (d?.action_taken?.length ?? 0) === 0) {
      errors.push({
        type: 'REQUIRED_FIELD',
        field: AlertActionTakenTriggerFields.ACTION_TAKEN,
        message: 'At least one action must be selected.',
      });
    }
    return errors.length > 0 ? errors : undefined;
  },

  CustomizationComponent: AlertActionTakenTriggerWithTagFilter,

  createDefaultNodeData: () =>
    buildNodeData('alert_action_taken_trigger', {
      select_all: false,
      alert_types: [],
      courier_ids: [],
      team_ids: [],
      origin_ids: [],
      destination_ids: [],
      product_ids: [],
      select_all_teams: false,
      select_all_origins: false,
      select_all_products: false,
      select_all_transport_providers: false,
      select_all_destinations: false,
      select_all_alert_types: false,
      action_taken: [],
      select_all_action_taken: false,
      tag_ids: [],
    }),
};
